import { useState } from 'react';

type DropZoneProps = {
  onDrop: () => void;
  disabled?: boolean;
};

export function DropZone({ onDrop, disabled }: DropZoneProps) {
  const [over, setOver] = useState(false);

  if (disabled) {
    return <div className='ee-dropzone' />;
  }

  return (
    <div
      className={`ee-dropzone ${over ? 'is-over' : ''}`}
      onDragOver={(e) => {
        e.preventDefault();
        setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => {
        e.preventDefault();
        setOver(false);
        onDrop();
      }}
    >
      {over && <div className='ee-dropzone__hint'>+ Drop block here</div>}
    </div>
  );
}
